export default "__VITE_ASSET__DYyqDdHC__"